import React, { useState } from 'react';
import { exportXLSX } from '../../../services/export';

import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import config from '../../../config/configJS';


const JsonTable = ({ id, columns, rows, /* generatedSQL */ }) => {
  const [numRowsToProcess, setNumRowsToProcess] = useState(config.numberOfRows); 

  if (
    !columns ||
    !Array.isArray(columns) ||
    columns.length === 0 ||
    !rows ||
    !Array.isArray(rows) ||
    rows.length === 0
  ) {
    return null;
  }

  const formatDateTable = (inputDate) => {
    var objectDate = new Date(inputDate);
    var day = objectDate.getDate();
    var month = objectDate.getMonth() + 1;
    var year = objectDate.getFullYear();
    var stringToDate = `${day}.${month}.${year}`;
    return stringToDate;
  };

  function cleanSqlString(sqlString) {
    if(sqlString == undefined){
      return "";
    }
    // Regular expression to remove backticks, 'sql', and whitespace at the start and end
    const cleanedString = sqlString.replace(/```sql\s*|\s*```/g, '').trim();
    return cleanedString;
  }

  const handleClick = (type) => {
    console.log('download as', type, 'from table', id);

    const data = rows.map((row) => {
      return row.reduce((obj, value, index) => {
        obj[columns[index].Name] = value;
        return obj;
      }, {});
    });

    exportXLSX(data, type);
  };

  let tableRows = [];

  for (let index = 0; index < numRowsToProcess && index < rows.length; index++) {
    let row = rows[index];
    let cells = [];

    for (let i = 0; i < row.length; i++) {
      switch (columns[i].DatabaseType) {
        case 'Decimal':
        case 'decimal':
        case 'Double':
        case 'double':
          const formattedNumber = row[i]?.toLocaleString('sk-SK', { maximumFractionDigits: 2 })
                .replace(/\s/g, ' ') // Ensure regular spaces for thousands

          cells.push(
            <td key={i}>{formattedNumber}</td>
          );
          break;
        case 'money':
          cells.push(
            <td key={i}>
              {row[i]?.toLocaleString('sk-SK', { style: 'currency', currency: 'EUR' })}
            </td>
          );
          break;
        case 'datetime':
          cells.push(<td key={i}>{formatDateTable(row[i])}</td>);
          break;
        default:
          cells.push(<td key={i}>{row[i]}</td>);
      }
    }

    tableRows.push(<tr key={index}>{cells}</tr>);
  }

  return (
    <>
      <div className="controls-container">
        <button className="download-button" id={id} type="xlsx" onClick={() => handleClick('xlsx')}>
          Excel
        </button>
        <button className="download-button" id={id} type="csv" onClick={() => handleClick('csv')}>
          Csv
        </button>
        <Tooltip title={'pre zobrazenie všetkých dát je potrebné spraviť export'}>
          <InfoIcon style={{ cursor: 'default', fill: 'lightgray' }} />
        </Tooltip>
      </div>

      <div className="msger-table-space">
        <div className="msger-table-wrapper">
          <table className="msger-table">
            <thead>
              <tr>
                {columns.map((column, index) => (
                  <th key={index}>{column.Name}</th>
                ))}
              </tr>
            </thead>
            <tbody>{tableRows}</tbody>
          </table>
        </div>
        {/* <div className="sql-wrapper">
          {cleanSqlString(generatedSQL)}
        </div> */}
      </div>
    </>
  );
};

export default JsonTable;
